import React, { useRef, useEffect, useState } from 'react';
import { useIntersection, useWindowSize, useWindowScroll } from 'react-use';
import styles from './reviews.module.scss';
import ReviewsModel from '../../models/reviews';
import Richtext from '../global/richtext/Richtext';
import RichTextModel from '../../models/richtext';
import Stars from './stars';

type Props = {
  data: ReviewsModel;
};

const Reviews = ({ data }: Props) => {
  const {
    title,
    primaryColor,
    secondaryColor,
    starColor,
    reviewItems,
    scrollRatio
  } = data;

  const reviewsRef = useRef<HTMLInputElement>(null);
  const [translation, setTranslation] = useState(0);
  const intersection = useIntersection(reviewsRef, {});
  const { height } = useWindowSize();
  const { y } = useWindowScroll();

  useEffect(() => {
    if (reviewsRef.current && intersection?.isIntersecting) {
      const { top } = reviewsRef.current.getBoundingClientRect();
      const horizontal = scrollRatio * (top - height);
      setTranslation(horizontal);
    }
  }, [y]);

  return (
    <div
      className={styles.reviews}
      style={{ color: primaryColor }}
      ref={reviewsRef}
    >
      <div
        className={styles.reviews__title}
        style={{ transform: `translateX(${translation}px)` }}
      >
        <span className={styles.reviews__title_item}>{title}</span>
        <span className={styles.reviews__title_item}>{title}</span>
        <span className={styles.reviews__title_item}>{title}</span>
        <span className={styles.reviews__title_item}>{title}</span>
      </div>
      {reviewItems?.map((review) => {
        const { id, rating, content, meta } = review;
        return (
          <div key={id} className={styles.review}>
            <div
              className={styles.review__rating}
              style={{
                clipPath: `inset(0 ${100 - (100 * rating) / 5}% 0 0)`,
                color: starColor
              }}
            >
              <Stars />
            </div>
            <div className={styles.review__content}>
              <Richtext data={new RichTextModel(content)} />
            </div>
            <div
              className={styles.review__meta}
              style={{ color: secondaryColor }}
            >
              {meta}
            </div>
            <div className={styles.review__separator} />
          </div>
        );
      })}
    </div>
  );
};

export default Reviews;
